import { useState } from 'react';
import { FormInput } from '@unified-checkout/kit-components';

import cvvIcon from '../../assets/icons/cvv-info.svg';
import { CVVToolTipModal } from './CVVToolTipModal';

export function CVV(props: any) {
  const {
    isIframe,
    maxLength,
    formRegister,
    error,
    disabled,
    customStyle,
    className,
    placeholder,
    customInputStyle,
    value,
    onChange,
    borderStyle,
    autoFocus,
  } = props;

  const [showModal, setShowModal] = useState<boolean>(false);

  const handleShowModal = () => {
    if (isIframe) {
      window.parent.postMessage({ type: 'openCVVToolTipModal' }, '*');
    } else {
      setShowModal(true);
    }
  };

  const onClose = () => {
    setShowModal(false);
  };
  return (
    <>
      <FormInput
        name="cvc"
        placeholder={placeholder || 'CVV'}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        formRegister={formRegister}
        className={className}
        error={error}
        type="password"
        borderStyle={borderStyle}
        disabled={disabled}
        label={
          !error && (
            <img
              onMouseDown={handleShowModal}
              onTouchStart={handleShowModal}
              src={cvvIcon}
              alt="cvv info"
              className="w-3 h-3 object-contain cursor-pointer"
            />
          )
        }
        inputMode="numeric"
        pattern={'d*'}
        maxLength={maxLength}
        customInputStyle={customInputStyle}
        customStyle={customStyle}
        autoComplete="cc-csc"
      />
      {showModal && !isIframe && <CVVToolTipModal onClose={onClose} showModal={showModal} />}
    </>
  );
}
